import { render, staticRenderFns } from "./UserDetailUpgradeActivity.vue?vue&type=template&id=131da23b&"
import script from "./UserDetailUpgradeActivity.vue?vue&type=script&lang=js&"
export * from "./UserDetailUpgradeActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports